import { handleActions } from 'redux-actions';
import { NOT_REQUESTED, REQUESTED, FAILED, SUCCEEDED } from 'forms-utils-lib/RequestState';
import { REQUEST_FORM_DEPENDENCIES, RECEIVE_FORM_DEPENDENCIES, FAIL_RECEIVE_FORM_DEPENDENCIES } from 'ui-forms-editor-automation-lib/actions/formDependencies';
export const INITIAL_STATE = {
  formDependencies: {},
  requestState: NOT_REQUESTED
};
export default handleActions({
  [REQUEST_FORM_DEPENDENCIES]: state => Object.assign({}, state, {
    requestState: REQUESTED
  }),
  [RECEIVE_FORM_DEPENDENCIES]: (_, {
    payload
  }) => ({
    formDependencies: payload,
    requestState: SUCCEEDED
  }),
  [FAIL_RECEIVE_FORM_DEPENDENCIES]: state => Object.assign({}, state, {
    requestState: FAILED
  })
}, INITIAL_STATE);